import { render, staticRenderFns } from "./ReportDisasterDetail.vue?vue&type=template&id=bb12c75a&scoped=true"
import script from "./ReportDisasterDetail.vue?vue&type=script&lang=js"
export * from "./ReportDisasterDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportDisasterDetail.vue?vue&type=style&index=0&id=bb12c75a&prod&scoped=true&lang=css"
import style1 from "./ReportDisasterDetail.vue?vue&type=style&index=1&id=bb12c75a&prod&lang=css"
import style2 from "./ReportDisasterDetail.vue?vue&type=style&index=2&id=bb12c75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb12c75a",
  null
  
)

export default component.exports